const ShareContent = () => {
  return (
    <div className="SharingContent">
      <h3>Bagikan Promo Ini</h3>
      <ul className="d-flex list-unstyled list-socmed">
        <li>
          <a onClick={() => {navigator.clipboard.writeText(window.location.href)}} className="a-copy-to-clipboard" href="javascript:void"><i className="a-system-icon icon-hyperlink"></i></a>
        </li>
        <li>
          <a target="_blank" rel="noreferrer" href={`https://twitter.com/intent/tweet?url=${window.location.href}`}><i className="a-system-icon icon-twitter"></i></a>
        </li>
        <li>
          <a target="_blank" rel="noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}><i className="a-system-icon icon-facebook"></i></a>
        </li>
        <li>
          <a target="_blank" rel="noreferrer" href={`https://wa.me/?text=${window.location.href}`}><i className="a-system-icon icon-social-whatsapp"></i></a>
        </li>
        <li>
          <a target="_blank" rel="noreferrer" href={`https://social-plugins.line.me/lineit/share?url=${window.location.href}`}><i className="a-system-icon icon-line"></i></a>
        </li>
      </ul>
    </div>
  )
}

export default ShareContent